require('./bootstrap');

import Dropzone from "dropzone";

Dropzone.autoDiscover = false;

$(document).ready(function () {

    // Header
    let navToggle = false;
    $('#nav-burger-btn').click(function () {

        if (!navToggle) {
            if (
                $('#nav-mob-wrap')
                    .removeClass('mobile-hide')
                    .addClass('mobile-show')
                    .addClass('mob-nav-border')
            ) {
                $('#nav-burger-btn #nav-burger-btn-icon').addClass('mobile-hide').removeClass('mobile-show')
                $('#nav-burger-btn #nav-close-btn-icon').removeClass('mobile-hide').addClass('mobile-show')
                $('header').addClass('fixed-header');
                $('body').css('overflow', 'hidden');
                navToggle = true
            }
        } else {
            if (
                $('#nav-mob-wrap')
                    .removeClass('mobile-show')
                    .addClass('mobile-hide')
                    .removeClass('mob-nav-border')
            ) {
                $('#nav-burger-btn #nav-close-btn-icon').addClass('mobile-hide').removeClass('mobile-show');
                $('#nav-burger-btn #nav-burger-btn-icon').removeClass('mobile-hide').addClass('mobile-show');
                $('header').removeClass('fixed-header');
                $('body').css('overflow', 'auto');
                navToggle = false;
            }
        }
    });
    // End of -> Header


    // Defaults
    var csrf = $('meta[name="csrf-token"]').attr('content');
    var recapchaKey = $('meta[name="recapcha-token"]').attr('content');
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': csrf
        }
    });
    // End of -> Defaults


    // Smooth Scrolling
    $('#all-jobs-btn').click(function () {
        var id = '#' + $(this).data('jump-to-id');
        $('html, body').animate({
            scrollTop: $(id).offset().top
        }, 800);
    });
    // End of -> Smooth Scrolling


    // Book a place form
    $('.book-a-place-btn').click(function () {
        $('#bodyOverlay').addClass('fadein');
    });

    $('#book-a-place-close-btn').click(function () {
        $('#bodyOverlay').removeClass('fadein');
    });

    if ($('#book-a-place-form').length) {
        var checkedVals = $('.bapf-checkbox:checkbox:checked').map(function () {
            return this.value;
        }).get();

        if (checkedVals.length == 1) {
            var checkboxToBeChecked = checkedVals[0];

            $('#inside-list-wrapper')
                .animate({
                    scrollTop: $('.bapf-checkbox[data-kindergarten-id="' + checkboxToBeChecked + '"]').offset().top
                });
        }

        $('.bapf-checkbox').on('change', function () {
            checkedVals = $('.bapf-checkbox:checkbox:checked').map(function () {
                return this.value;
            }).get();

            if (checkedVals.length > 3) {
                $(this).prop("checked", false);
                $('#bapf-error p').html('Sie können maximal drei Standorte auswählen');
                if (!$('#bapf-error').hasClass('clicked_once')) {
                    $('#bapf-error > div').removeClass('arrow_to_bottom').addClass('arrow_to_top');
                    $('#bapf-error')
                        .addClass('clicked_once')
                        .insertAfter($(this).closest('.kindergarten-box'))
                        .removeClass('none')
                        .fadeIn(500)
                        .delay(3000)
                        .fadeOut(500, function () {
                            $('#bapf-error').removeClass('clicked_once').prependTo($('#body'));
                            $('#bapf-error > div').removeClass('arrow_to_top').addClass('arrow_to_bottom');
                        });
                }
            } else if (checkedVals.length <= 0) {
                $('#book-a-place-form #header #nav #bapf-nav-link-1 p span').addClass('none')
            }
        });

        $('#book-a-place-next-button').click(function () {
            if (checkedVals.length > 0) {
                $('#book-a-place-form #body #kindergartens-list').addClass('none')
                $('#book-a-place-form #body #contact').addClass('none')
                $('#book-a-place-form #body #kid').removeClass('none')
                $('#book-a-place-form #header #nav #bapf-nav-link-1').removeClass('active')
                $('#book-a-place-form #header #nav #bapf-nav-link-3').removeClass('active')
                $('#book-a-place-form #header #nav #bapf-nav-link-2').addClass('active')
                $('#book-a-place-form #footer #back-btn-wrap #book-a-place-back-button').removeClass('none')
                $('#book-a-place-kids-button').removeClass('none');
                $(this).addClass('none');
                $('#book-a-place-apply-button').addClass('none');
                $('#book-a-place-form #header #nav #bapf-nav-link-1 p span').removeClass('none')
                $('#book-a-place-form #bapf-error').hide()
            } else {
                $('#bapf-error p').html('Wählen Sie mindestens einen Standort aus')
                if (!$('#bapf-error').hasClass('clicked_once')) {
                    $('#bapf-error').removeClass('none').addClass('clicked_once').fadeIn(500).delay(5000).fadeOut(500, function () {
                        $('#bapf-error').removeClass('clicked_once');
                    });
                }
            }
        })


        $('#book-a-place-kids-button').click(function () {
            if (checkedVals.length > 0) {
                $('#book-a-place-form #body #kindergartens-list').addClass('none')
                $('#book-a-place-form #body #kid').addClass('none')
                $('#book-a-place-form #body #contact').removeClass('none')
                $('#book-a-place-form #header #nav #bapf-nav-link-1').removeClass('active')
                $('#book-a-place-form #header #nav #bapf-nav-link-2').removeClass('active')
                $('#book-a-place-form #header #nav #bapf-nav-link-3').addClass('active')
                $('#book-a-place-form #footer #back-btn-wrap #book-a-place-back-button').removeClass('none')
                $('#book-a-place-apply-button').removeClass('none');
                $(this).addClass('none');
                $('#book-a-place-next-button').addClass('none');
                $('#book-a-place-form #header #nav #bapf-nav-link-2 p span').removeClass('none')
                $('#book-a-place-form #bapf-error').hide()
            } else {
                $('#bapf-error p').html('Name des Kindes, Geburtsdatum des Kindes, Gewünschtes Eintrittsdatum muss ausgefüllt werden.')                
                if (!$('#bapf-error').hasClass('clicked_once')) {
                    $('#bapf-error').removeClass('none').addClass('clicked_once').fadeIn(500).delay(5000).fadeOut(500, function () {
                        $('#bapf-error').removeClass('clicked_once');
                    });
                }
            }
        })

        $('#book-a-place-back-button').click(function () {
            $(this).addClass('none');
            $('#book-a-place-form #bapf-error').hide()
            var currentBtn = $('#next-btn-wrap').find('.btn-t1:not(".none")');

            if($(currentBtn).length){
                var btnId = $(currentBtn).attr('id');
                if(btnId == 'book-a-place-kids-button'){
                        $('#book-a-place-form #body #kid').addClass('none')
                        $('#book-a-place-form #body #contact').addClass('none')
                        $('#book-a-place-form #body #kindergartens-list').removeClass('none')
                        $('#book-a-place-form #header #nav #bapf-nav-link-1').addClass('active')
                        $('#book-a-place-form #header #nav #bapf-nav-link-2').removeClass('active')
                        $('#book-a-place-form #header #nav #bapf-nav-link-3').removeClass('active')
                        $('#book-a-place-kids-button').addClass('none');
                        $('#book-a-place-apply-button').addClass('none');
                        $('#book-a-place-next-button').removeClass('none');
                        $('#book-a-place-form #footer #back-btn-wrap #book-a-place-back-button').addClass('none')
                }else{
                    if(btnId == 'book-a-place-apply-button'){
                        $('#book-a-place-form #body #kindergartens-list').addClass('none')
                        $('#book-a-place-form #body #contact').addClass('none')
                        $('#book-a-place-form #body #kid').removeClass('none')
                        $('#book-a-place-form #header #nav #bapf-nav-link-1').removeClass('active')
                        $('#book-a-place-form #header #nav #bapf-nav-link-3').removeClass('active')
                        $('#book-a-place-form #header #nav #bapf-nav-link-2').addClass('active')
                        $('#book-a-place-apply-button').addClass('none');
                        $('#book-a-place-next-button').addClass('none');
                        $('#book-a-place-kids-button').removeClass('none');
                        $(this).removeClass('none')
                        $('#book-a-place-form #footer #back-btn-wrap #book-a-place-back-button').removeClass('none');
                    }else{
                        $('#book-a-place-form #body #kid').addClass('none')
                        $('#book-a-place-form #body #contact').addClass('none')
                        $('#book-a-place-form #body #kindergartens-list').removeClass('none')
                        $('#book-a-place-form #header #nav #bapf-nav-link-1').addClass('active')
                        $('#book-a-place-form #header #nav #bapf-nav-link-2').removeClass('active')
                        $('#book-a-place-form #header #nav #bapf-nav-link-3').removeClass('active')
                        $('#book-a-place-kids-button').addClass('none');
                        $('#book-a-place-apply-button').addClass('none');
                        $('#book-a-place-next-button').removeClass('none');
                        $('#book-a-place-form #footer #back-btn-wrap #book-a-place-back-button').addClass('none')
                    }
                }
            }

        })

        $('#book-a-place-apply-button').click(function () {
            if ($('input#parentName').val() !== '' && $('input#phone').val() !== '' && $('input#email').val() !== '') {
                if ($('#book-a-place')) {
                    $('#book-a-place').find('#captchaToken').remove();
                    grecaptcha.ready(function () {
                        grecaptcha.execute(recapchaKey, {action: 'submit'}).then(function (token) {
                            // Add your logic to submit to your backend server here.
                            $('#book-a-place').append('<input id="captchaToken" type="hidden" value="' + token + '" name="captchaToken" />').promise().done(function () {
                                var formData = $('#book-a-place');
                                var url = $(formData).attr('action');

                                $.ajax({
                                    type: "POST",
                                    url: url,
                                    data: formData.serialize(),
                                    async: true,
                                    success: function (data) {

                                        $('#bodyOverlay').find('#header h3').text(' ').trigger('change');
                                        $('#bodyOverlay').find('#nav').remove();
                                        $('#bodyOverlay').find('form').remove();
                                        $(data).insertAfter($('#bodyOverlay').find('#header'));
                                    },
                                    error: function (data) {

                                        $('#bodyOverlay').find('#header h3').text(' ').trigger('change');
                                        $('#bodyOverlay').find('#nav').remove();
                                        $('#bodyOverlay').find('form').remove();
                                        $(data).insertAfter($('#bodyOverlay').find('#header'));

                                    }
                                });
                            });
                        });
                    });

                }
                return false;


            } else {
                $('#bapf-error p').html('Bitte füllen Sie alle Eingabefelder aus')
                if (!$('#bapf-error').hasClass('clicked_once')) {
                    $('#bapf-error').removeClass('none').fadeIn(500).delay(5000).fadeOut(500, function () {
                        $('#bapf-error').removeClass('clicked_once');
                    });
                }
            }
        })
        // End of -> Book a place form
    }

    // Location Page
    $('#location-book-btn-wrapper').addClass('about-panel-btn-center');
    $('#location-page .tab-link').click(function () {
        var bodyIdToDisplay = $(this).attr('href');

        $('.tab-link').removeClass('active');
        $(this).addClass('active');

        if (bodyIdToDisplay == '#about-tab-body') {
            $('#location-book-btn-wrapper').addClass('about-panel-btn-center');
        } else {
            $('#location-book-btn-wrapper').removeClass('about-panel-btn-center');
        }

        $('.tab-body-inner-wrapper').removeClass('block').addClass('none');
        $(bodyIdToDisplay).removeClass('none').addClass('block');

        return false;
    });
    // End of -> Location Page


    // Jobs apply form
    $('.jobs-apply-button').click(function () {
        $('#bodyOverlay').addClass('fadein');
        gtag('event', 'BeginJobApplication', {
          'event_category' : 'JobsBeiHeidi',
          'event_label' : 'BeginJobApplication'
        });
        // $('#jobs_apply_form #jobId').val($(this).data('job-id'));
    });
    if ($('#jobsApplyDropzone').length) {

        if ($('#jobs_apply')) {
            $('#jobs_apply').find('#captchaToken').remove();
            grecaptcha.ready(function () {
                grecaptcha.execute(recapchaKey, {action: 'fileUpload'}).then(function (token) {

                    let jobsApplyDropzone = new Dropzone("#jobsApplyDropzone", {
                        dictDefaultMessage: 'Legen Sie Dateien hier ab um Sie hochzuladen',
                        dictFallbackMessage: 'Ihr Browser unterstützt Drag&Drop Dateiuploads nicht',
                        dictFallbackText: 'Benutzen Sie das Formular um Ihre Dateien hochzuladen',
                        dictFileTooBig: 'Die Datei ist zu groß. Die maximale Dateigröße beträgt {{maxFileSize}}MB',
                        dictInvalidFileType: 'Eine Datei dieses Typs kann nicht hochgeladen werden',
                        dictResponseError: 'Der Server hat ihre Anfrage mit Status {{statusCode}} abgelehnt',
                        dictCancelUpload: 'Hochladen abbrechen',
                        dictCancelUploadConfirmation: null,
                        dictRemoveFile: 'Datei entfernen',
                        dictMaxFilesExceeded: 'Sie können keine weiteren Dateien hochladen. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
                        url: "/cv/save",
                        maxFilesize: 20,
                        headers: {
                            'X-CSRF-TOKEN': csrf
                        },
                        params: function () {
                            return {
                                captchaToken: token,
                                jobId: $('#jobs_apply_form #jobId').val()
                            };
                        },
                        maxFiles: 1,
                        acceptedFiles: 'application/pdf,.doc,.docx,.png,.jpg,.jpeg,.heic,.jpe',
                        success: function (file, response) {
                            $('.dz-preview, .dz-image').addClass('w-100 h-100');
                            if (!response) {
                                $('#jaf-error').removeClass('none').fadeIn(500).delay(7000).fadeOut(500);
                                $('#jaf-error p').html('Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.');

                                setTimeout(function () {
                                    window.location.reload(true);
                                }, 8000);
                            } else {
                                $('#cv_path').val(response);
                            }
                        }, error: function (file, message) {

                            $(file.previewElement).remove();
                            $('#jaf-error').removeClass('none').fadeIn(500).delay(7000).fadeOut(500);
                            if(message)
                                $('#jaf-error p').html(message);
                            else
                                $('#jaf-error p').html('Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.');

                            setTimeout(function () {
                                window.location.reload(true);
                            }, 8000);

                        },
                        init: function () {


                        }
                    });


                });
            });
        }
    }

    $('#jobs_apply_form_submit_button').click(function () {
        if ($('input#name').val() !== '' && $('input#phone').val() !== '' && $('input#email').val() !== '') {
            if ($('#jobs_apply')) {
                $('#jobs_apply').find('#captchaToken').remove();
                grecaptcha.ready(function () {
                    grecaptcha.execute(recapchaKey, {action: 'submit'}).then(function (token) {

                        $('#jobs_apply').append('<input id="captchaToken" type="hidden" value="' + token + '" name="captchaToken" />').promise().done(function () {
                            var formData = $('#jobs_apply');
                            var url = $(formData).attr('action');

                            gtag('event', 'SendJobApplication', {
                              'event_category' : 'JobsBeiHeidi',
                              'event_label' : 'SendJobApplication'
                            });

                            $.ajax({
                                type: "POST",
                                url: url,
                                data: formData.serialize(),
                                async: true,
                                success: function (data) {

                                    $('#bodyOverlay').find('header h3').text(' ').trigger('change');
                                    $('#bodyOverlay').find('form').remove();
                                    $(data).insertAfter($('#bodyOverlay').find('header'));
                                },
                                error: function (data) {

                                    $('#bodyOverlay').find('header h3').text(' ').trigger('change');
                                    $('#bodyOverlay').find('form').remove();
                                    $(data).insertAfter($('#bodyOverlay').find('header'));
                                }
                            });

                        });
                    });
                });
            }

        } else {
            $('#jaf-error').removeClass('none').fadeIn(500).delay(5000).fadeOut(500);
            $('#jaf-error p').html('Bitte füllen Sie alle Eingabefelder aus')
        }
    });
    $('#jobs-apply-close-btn').click(function () {
        $('#bodyOverlay').removeClass('fadein');
    });
    // End of -> Jobs apply form


    // Locations page
    $('.locations-tab-links').click(function () {
        var bodyIdToDisplay = $(this).attr('href');

        $('.locations-tab-links-wrapper').removeClass('active');
        $(this).parent().addClass('active');

        $('#locations .flexed .locations-sides').addClass('mobile-none');
        $(bodyIdToDisplay).removeClass('mobile-none');

        if (bodyIdToDisplay === '#locations-left-box') {
            $('#map-box').addClass('mobile-none');
        }

        return false;
    });

    /* Map */
    $('.location-link-element').hover(
        function () {
            $('#locations-right-box > svg > .kindergarten_map_path_body').css('fill-opacity', '0.2');
            $('#locations-right-box > svg > .kindergarten_map_path_elements').css('fill', '#50AF38');
            $('#map-box').addClass('none');

            $('.location-link-element').each(function () {
                $(this).find('.location-link-box').removeClass('active');
            })

            let kindergartenId = $(this).data('id');
            let kindergartenName = $(this).data('name');
            let kindergartenAddress = $(this).data('address');
            let kindergartenSlug = $(this).data('slug');

            $('#map-box > a').attr('href', '/standorte/' + kindergartenSlug);
            $('#map-box > a > .map-box-name').text(kindergartenName);
            $('#map-box > .map-box-address').text(kindergartenAddress);
            // $('#map-box > .map-box-link').attr('href', '/standorte/' + kindergartenSlug);

            $('#map-box').removeClass('none')
                .css('left', parseInt($('#locations-right-box > svg > .kindergarten_location_' + kindergartenId)
                    .position().left - 40))
                .css('top', $('#locations-right-box > svg > .kindergarten_location_' + kindergartenId)
                    .position().top)

            $('#locations-right-box > svg > .kindergarten_body_location_' + kindergartenId).css('fill-opacity', '1.0');
            $('#locations-right-box > svg > .kindergarten_location_' + kindergartenId).css('fill', '#fff');
        },
        function () {
            let kindergartenId = $(this).data('id');

            $('#locations-right-box > svg > .kindergarten_body_location_' + kindergartenId).css('fill-opacity', '0.2');
            $('#locations-right-box > svg > .kindergarten_location_' + kindergartenId).css('fill', '#50AF38');
            $('#map-box').addClass('none');
        }
    );

    let prevPath = '';
    $('.kindergarten_map_path_body').hover(function () {

            $('.location-link-element').find('.location-link-box').removeClass('active');
            $('#locations-right-box > svg > .kindergarten_body_location_' + prevPath).css('fill-opacity', '0.2');
            $('#locations-right-box > svg > .kindergarten_location_' + prevPath).css('fill', '#50AF38');
            $('#map-box').addClass('none');

            let classesAsStr = $(this).attr('class');
            let classesArray = classesAsStr.split(' ');
            let kindergartenId = classesArray.pop();
            let listElement = $('.location-link-element[data-id="' + kindergartenId + '"]');
            let kindergartenName = $(listElement).data('name');
            let kindergartenAddress = $(listElement).data('address');
            let kindergartenSlug = $(listElement).data('slug');

            if ($(window).width() > 1023)
                $(listElement).find('.location-link-box').addClass('active');

            $('#map-box > a').attr('href', '/standorte/' + kindergartenSlug);
            $('#map-box > a > .map-box-name').text(kindergartenName);
            $('#map-box > .map-box-address').text(kindergartenAddress);
            // $('#map-box > .map-box-link').attr('href', '/standorte/' + kindergartenSlug);

            $('#map-box').removeClass('none mobile-none')
                .css('left', parseInt($('#locations-right-box > svg > .kindergarten_location_' + kindergartenId)
                    .position().left - 40))

                .css('top', $('#locations-right-box > svg > .kindergarten_location_' + kindergartenId)
                    .position().top)

            $('#locations-right-box > svg > .kindergarten_body_location_' + kindergartenId).css('fill-opacity', '1.0');
            $('#locations-right-box > svg > .kindergarten_location_' + kindergartenId).css('fill', '#fff');

            prevPath = kindergartenId;

            if ($(window).width() > 1023) {
                var parentDiv = $('#locations-list-wrapper');
                var innerListItem = $(listElement).closest('.home-location-link');
                var scrollTopNumber = parentDiv.scrollTop() + parseInt($(innerListItem).position().top);

                if (parentDiv && innerListItem) {
                    setTimeout(function () {
                        $(parentDiv).animate({
                            scrollTop: parseInt(scrollTopNumber)
                        }, 400);
                    }, 20);
                }
            }


        },
        function () {


        });

    $('#locations_page').hover(
        function () {

        },
        function () {
            $('.location-link-element').find('.location-link-box').removeClass('active');
            $('#locations-right-box > svg > .kindergarten_body_location_' + prevPath).css('fill-opacity', '0.2');
            $('#locations-right-box > svg > .kindergarten_location_' + prevPath).css('fill', '#50AF38');
            $('#map-box').addClass('none');
        }
    );
    // End of -> Locations page


});


// Google Maps
function initMap() {
    const vienna = {lat: 48.2033072, lng: 16.3559573};

    const map = new google.maps.Map(document.getElementById("gmap"), {
        zoom: 11,
        center: vienna,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
    });

    // Here - Foreach location (marker)
    /*const marker = new google.maps.Marker({
        position: vienna,
        map: map,
    });*/
}

window.initMap = initMap;
// End of -> Google Maps
